import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getOrderGeneratorsFieldsWorksPlanWorks(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		options
	)
}

function _getOrderGeneratorsFieldsWorksPlanWork(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK,
		options
	)
}

function _getOrderGeneratorsFieldsWorksPlanWorksRelatedPlanWorks(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS_RELATED_PLAN_WORKS,
		options
	)
}

function _createOrderGeneratorsFieldsWorksPlanWork(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK,
		options
	)
}

function _createOrderGeneratorsFieldsWorksPlanWorkBulk(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK_BULK,
		options
	)
}

function _putOrderGeneratorsFieldsWorksPlanWork(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].PUT_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK,
		options
	)
}

function _patchOrderGeneratorsFieldsWorksPlanWork(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK,
		options
	)
}

function _deleteOrderGeneratorsFieldsWorksPlanWork(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK,
		options
	)
}

function _getOrderGeneratorsFieldsWorksPlanWorkPreview(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK_PREVIEW,
		options
	)
}

function _getOrderGeneratorsFieldsWorksPlanWorkPopup(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK_POPUP,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS]: _getOrderGeneratorsFieldsWorksPlanWorks,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK]: _getOrderGeneratorsFieldsWorksPlanWork,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS_RELATED_PLAN_WORKS]: _getOrderGeneratorsFieldsWorksPlanWorksRelatedPlanWorks,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK_PREVIEW]: _getOrderGeneratorsFieldsWorksPlanWorkPreview,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK_POPUP]: _getOrderGeneratorsFieldsWorksPlanWorkPopup,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK]: _createOrderGeneratorsFieldsWorksPlanWork,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK_BULK]: _createOrderGeneratorsFieldsWorksPlanWorkBulk,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].PUT_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK]: _putOrderGeneratorsFieldsWorksPlanWork,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK]: _patchOrderGeneratorsFieldsWorksPlanWork,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK]: _deleteOrderGeneratorsFieldsWorksPlanWork,
}